<!-- Header -->
<div class="min-[991px]:hidden px-[16px] my-[24px]">
    <app-auto-registration-top-bar
        logoSrc="assets/img/glameraTradeMarkLogo2.png"
        [logoWidth]="132"
        [mobileLogoWidth]="110"
        languageColor="#000"
        [darkMode]="true"
        (watchVideo)="onOpenVideo()"
    ></app-auto-registration-top-bar>
</div>

<!-- Title & Back Button -->
<div class="flex items-center justify-start px-[16px] min-[991px]:px-[48px] mt-[10px] min-[991px]:mt-[62px] mb-[26px] min-[991px]:mb-[30px]">
    <!-- Close Button -->
    <div class="max-[991px]:hidden w-[32px] h-[32px] rounded-[50px] bg-[#F9F9FA] me-[26px] cursor-pointer flex items-center justify-center"
        (click)="onCloseTermsSidenav()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 11.6667L11.6667 1M1 1L11.6667 11.6667" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>

    <!-- Back Button -->
    <div class="min-[991px]:hidden w-[32px] h-[32px] rounded-[50px] bg-[#F9F9FA] me-[12px] min-[991px]:me-[26px] cursor-pointer flex items-center justify-center"
        (click)="onCloseTermsSidenav()">
        <svg [ngClass]="dir == 'ar' ? 'rotate-180' : ''" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.90625 0.28125L0.28125 2.90622M0.28125 2.90622L2.90625 5.53122M0.28125 2.90622H7.03125" stroke="#2F384C" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
    <h3 class="text-[#000] font-[500] text-[16px] min-[991px]:text-[24px] m-0">
        {{ 'terms_and_conditions' | translate }}
    </h3>
</div>

<!-- Terms & Conditions Content -->
<div class="terms-content mat-typography"
    class="px-[16px] min-[991px]:px-[48px] pb-[14px]">
  <h1 class="main-heading">{{ 'TERMS.MAIN_HEADING' | translate }}</h1>
  <p>{{ 'TERMS.FIRST_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.OVERVIEW' | translate }}</h3>
  <p>{{ 'TERMS.SECOND_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.FIRST' | translate }}</h3>
  <p>{{ 'TERMS.THIRD_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.SECOND' | translate }}</h3>
  <p>{{ 'TERMS.FOURTH_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.THIRD' | translate }}</h3>
  <p>{{ 'TERMS.FIFTH_PARAGRAPH' | translate }}</p>

  <h3>{{ 'TERMS.SIGNUP_TITLE' | translate }}</h3>
  <ol>
    <li>{{ 'TERMS.SIGNUP_1' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_2' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_3' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_4' | translate }}</li>
    <li>{{ 'TERMS.SIGNUP_5' | translate }}</li>
  </ol>
  
  <h3>{{ 'TERMS.FREE_TRIAL_TITLE' | translate }}</h3>
  <ul>
    <li>{{ 'TERMS.FREE_TRIAL_1' | translate }}</li>
    <li>{{ 'TERMS.FREE_TRIAL_2' | translate }}</li>
  </ul>
  
  <h4>{{ 'TERMS.CANCEL_TITLE' | translate }}</h4>
  <p>{{ 'TERMS.CANCEL_INTRO' | translate }}</p>
  <ul>
    <li>{{ 'TERMS.CANCEL_1' | translate }}</li>
    <li>{{ 'TERMS.CANCEL_2' | translate }}</li>
  </ul>

  <h3>{{ 'TERMS.TERMINATE_TITLE' | translate }}</h3>
  <ul>
    <li>{{ 'TERMS.TERMINATE_1' | translate }}</li>
    <li>{{ 'TERMS.TERMINATE_2' | translate }}</li>
    <li>{{ 'TERMS.TERMINATE_3' | translate }}</li>
  </ul>
</div>
